import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/platform/")({
  beforeLoad: () => {
    throw redirect({ to: "/platform/popupManagement" });
  },
});
